import { render } from "./BigKPI.vue?vue&type=template&id=65de3866"
import script from "./BigKPI.vue?vue&type=script&lang=js"
export * from "./BigKPI.vue?vue&type=script&lang=js"

import "./BigKPI.vue?vue&type=style&index=0&id=65de3866&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__